import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "ggdy-bts"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_toolbar = _resolveComponent("vxe-toolbar");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_vxe_input = _resolveComponent("vxe-input");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _directive_el_select_loadmore = _resolveDirective("el-select-loadmore");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_vxe_toolbar, null, {
    buttons: _withCtx(() => [_ctx.pagetype !== 'gyskj' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
      class: "l-button",
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.addRow && _ctx.addRow(...args))
    }, "新增行"), _createElementVNode("div", {
      class: "l-button",
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.deletRow && _ctx.deletRow(...args))
    }, "删除行")])) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_vxe_table, {
    id: "bzljtableid",
    ref: "bzljtable",
    onCheckboxChange: _ctx.selectionChange,
    onCheckboxAll: _ctx.selectAllChange,
    "max-height": "400",
    "keep-source": "",
    "custom-config": {
      storage: true
    },
    border: "",
    "show-overflow": "",
    data: _ctx.data.thebzljxzTableData,
    "column-config": {
      resizable: true
    },
    "sort-config": {
      remote: false
    },
    "edit-config": {
      trigger: 'click',
      mode: 'cell',
      showUpdateStatus: true,
      showInsertStatus: true
    },
    class: "ggdycss"
  }, {
    default: _withCtx(() => [_createVNode(_component_vxe_column, {
      type: "checkbox",
      width: "50",
      align: "center"
    }), _createVNode(_component_vxe_column, {
      type: "seq",
      width: "50",
      title: "序号",
      align: "center"
    }), _createVNode(_component_vxe_column, {
      field: "bom_code",
      title: "零件编码",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "200",
      align: "left"
    }, {
      default: _withCtx(({
        row
      }) => [_createElementVNode("span", null, _toDisplayString(row.bom_code), 1)]),
      edit: _withCtx(({
        row
      }) => [_withDirectives((_openBlock(), _createBlock(_component_el_select, {
        modelValue: row.bom_code,
        "onUpdate:modelValue": $event => row.bom_code = $event,
        "remote-method": _ctx.remoteMethod,
        loading: _ctx.data.loading,
        clearable: "",
        filterable: "",
        remote: "",
        placeholder: "请选择物料代码",
        onChange: $event => _ctx.bomchange($event, row.indextb),
        "data-popper-placement": "bottom",
        disabled: _ctx.pagetype == 'gyskj'
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.bomlist, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.bom_code,
            label: item.bom_code,
            value: item.bom_code,
            class: "vxe-table--ignore-clear"
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method", "loading", "onChange", "disabled"])), [[_directive_el_select_loadmore, _ctx.loadmore]])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "bom_name",
      title: "零件名称",
      width: "200",
      align: "left"
    }, {
      default: _withCtx(({
        row
      }) => [_createElementVNode("span", null, _toDisplayString(row.bom_name), 1)]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "spec",
      title: "零件规格型号",
      width: "200",
      align: "left"
    }, {
      default: _withCtx(({
        row
      }) => [_createElementVNode("span", null, _toDisplayString(row.spec), 1)]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "molecule",
      title: "用量（分子）",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "120",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [_createVNode(_component_vxe_input, {
        modelValue: row.molecule,
        "onUpdate:modelValue": $event => row.molecule = $event,
        type: "integer",
        min: "0",
        max: "999"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "denominator",
      title: "用量（分母）",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      width: "180",
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [_createVNode(_component_vxe_input, {
        modelValue: row.denominator,
        "onUpdate:modelValue": $event => row.denominator = $event,
        type: "integer",
        min: "0",
        max: "999"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "remark",
      title: "备注",
      "edit-render": {
        autofocus: '.vxe-input--inner'
      },
      align: "left"
    }, {
      edit: _withCtx(({
        row
      }) => [_createVNode(_component_vxe_input, {
        modelValue: row.remark,
        "onUpdate:modelValue": $event => row.remark = $event,
        modelModifiers: {
          trim: true
        },
        maxlenth: "200"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["onCheckboxChange", "onCheckboxAll", "data"])]);
}